import { render, staticRenderFns } from "./OrdersPerClientReport.vue?vue&type=template&id=6fca00b1&"
import script from "./OrdersPerClientReport.vue?vue&type=script&lang=js&"
export * from "./OrdersPerClientReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports